exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-popper-arrow]{right:-8px;border-top:8px solid #0000;border-bottom:8px solid #0000;border-left:8px solid #e0e0e0}.comments-tab-content{max-height:300px;overflow:scroll}.job-comment-counter-card{background-color:#fff;width:500px;max-width:50vw}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05d0fc01","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Job/Comments/Counter.vue
// module id = 1DrF
// module chunks = 0